import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a72b343"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-visitor" }
const _hoisted_2 = { class: "i-visitor-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "item-p" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-p__left" }, "访问公司：", -1))
const _hoisted_6 = { class: "item-p__right" }
const _hoisted_7 = { class: "item-p" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-p__left" }, "来访人：", -1))
const _hoisted_9 = { class: "item-p__right" }
const _hoisted_10 = { class: "item-p" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-p__left" }, "访问时间：", -1))
const _hoisted_12 = { class: "item-p__right" }
const _hoisted_13 = {
  key: 0,
  class: "item-state approve"
}
const _hoisted_14 = {
  key: 1,
  class: "item-state visit"
}
const _hoisted_15 = {
  key: 2,
  class: "item-state pass"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.refreshing,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.refreshing) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: _ctx.loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
          finished: _ctx.finished,
          "finished-text": "没有更多了",
          onLoad: _ctx.onLoad
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitorList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "i-visitor-item",
                  onClick: ($event: any) => (
              _ctx.$router.push({
                name: _ctx.$RouterName.VISITOR_INVITATION,
                params: {
                  id: item.detail_code
                }
              })
            )
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.visit_stores_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.person_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, _toDisplayString(item.person_date) + " " + _toDisplayString(item.person_time), 1)
                  ]),
                  (item.state == '1')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, "待审批"))
                    : _createCommentVNode("", true),
                  (item.state == '2')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, "已通过"))
                    : _createCommentVNode("", true),
                  (item.state == '3')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, "未通过"))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_3))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ]))
}